// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import Nestable from "react-nestable";

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {
    GetCategories,
    DeleteCategoryById,
    UpdateCategoryById,
    UpdateCategoriesPositions
} from "../../redux/actions";

// Import components
import {NestableItem} from "../../components/cards/nestableItem";
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import PageHeader from "../../components/pageContentViews/pageHeader";
import {deleteItem} from "../../utils/helperFunctions";


class Category extends Component {
    constructor(props) {
        super(props);

        this.deleteCategoryItem = this.deleteCategoryItem.bind(this);
    }

    componentDidMount() {
        this.props.GetCategories();
    }

    deleteCategoryItem(id){
        this.props.DeleteCategoryById(id).then(()=>{
            this.props.GetCategories();
        })
    }


    findParent(currentItem, id) {
        if (currentItem.children && currentItem.children.length &&
            currentItem.children.find(item => item.id === id)) {
            let movedItemNewIndex = -1;
            const positionedItems = currentItem.children.map((item, index) => {
                item.id === id && (movedItemNewIndex = index);
                return {id: item.id, position: index}
            });
            return {
                parent: currentItem.id,
                movedItemNewIndex: movedItemNewIndex,
                positionedItems
            };
        } else {
            let resData = null;
            currentItem.children && currentItem.children.length && currentItem.children.forEach(item => {
                let result = this.findParent(item, id);
                if (result) {
                    resData = result;
                }
            });
            return resData;
        }
    }

    getNestableItems(list, parent = null) {
        const items = [];
        list && !!list.length && list.forEach((item, index) => {
            const title = item?.title || '';

            items.push({
                id: item.id,
                index: index,
                title: title,
                isHidden: item.is_hidden,
                link: {
                    pathname: `categories/edit/${item.id}`,
                },
                deleteCb: deleteItem.bind(this, this.deleteCategoryItem, 'կատեգորիան', item.id),
                children: !!item.subCategories?.length ? this.getNestableItems(item.subCategories, item.id) : []
            })
        });
        return items;
    }


    render() {
        let {categoriesList} = this.props;
        let items = this.getNestableItems(categoriesList);
        return <PageWrapper pageTitle={'Կատեգորիաներ'}>
            <PageHeader linkTitle={"Ավելացնել"}
                        addingLink={"/categories/add"}/>
            {items && items.length !== 0 &&
            <Nestable
                items={items}
                maxDepth={3}
                handler={()=>{}}
                onChange={this.onPositionChange}
                renderItem={NestableItem}
            />}
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetCategories,
    DeleteCategoryById,
    UpdateCategoryById,
    UpdateCategoriesPositions
};

export default connect(mapStateToProps, mapDispatchToProps)(Category);
